import { Accordion, AccordionDetails, AccordionSummary, Button, Divider, Grid } from "@mui/material";
import { GridExpandMoreIcon } from "@mui/x-data-grid";
import DeleteIcon from '@mui/icons-material/Delete';

import IconsColor from "../../../../../utility/iconsColor";

import globalStyles from "../../../../../../assets/styles/global.module.scss";
import styles from "../../../../../../assets/styles/componentStyles/templateLibraryStyles/modifyWhatsAppTemplate/whatsAppTemplateForm.module.scss";

import { useShallow } from "zustand/react/shallow";
import { useTemplateLibraryStore } from "../../../../../../store/templateLibraryStore";
import { whatsappCarouselCardData } from "../../../../../../models/axiosModel";
import { primaryColor } from "../../../../../../utils/colors";
import { useCarouselFunctions } from "../../../utils/useCarouselFunctions";

import Required from "../../../../../utility/required";
import CarouselFormCardHeader from "./CarouselFormCardHeader";
import CarouselFormCardBody from "./CarouselFormCardBody";
import CarouselFormCardFooter from "./CarouselFormCardFooter";
import CarouselFormCardBodyDescription from "./CarouselFormCardBodyDescription";
import CarouselFormCardButtons from "./CarouselFormCardButtons";
import TouchTooltip from "../../../utils/TouchTooltip";
import { canDeleteCard, CAROUSEL_TEMPLATE_ADD_CARD_TOOLTIP_TEXT, CREATED_CAROUSEL_TEMPLATE_ADD_CARD_TOOLTIP_TEXT, getCarouselCards, isTemplateCreated, MAX_CAROUSEL_CARDS } from "../../../constant";

const CarouselFormCard = (props: any) => {

    const { carouselFiles, isFileUploaded, uploadFileHandlerCarousel, removeFileHandlerCarousel, handleAddNewCard, handleDeleteCard, handleChangeText, 
        getInput, flagShowVariableTooltipForVisitWebsite, checkForAddDynamicVar, carouselInvalidId, handleSampleTextChangeCarousel, 
        getWebsiteUrlValue 
    } = props;

    const { createTemplatePayload } = useTemplateLibraryStore(useShallow((state) => ({
        createTemplatePayload: state.createTemplatePayload,
    })));

    const { checkDisableAddBtnForCarouselMax10Cards } = useCarouselFunctions();

    const isMaxCardsReached = checkDisableAddBtnForCarouselMax10Cards();
    const shouldShowAddCardButton = !isTemplateCreated(createTemplatePayload);
    const isAddCardButtonDisabled = isTemplateCreated(createTemplatePayload) || checkDisableAddBtnForCarouselMax10Cards();

    const getAddCardTooltipText = () => {
        if (isTemplateCreated(createTemplatePayload)) {
            return CREATED_CAROUSEL_TEMPLATE_ADD_CARD_TOOLTIP_TEXT;
        }
        if (isMaxCardsReached) {
            return CAROUSEL_TEMPLATE_ADD_CARD_TOOLTIP_TEXT;
        }
        return "";
    };

    const addCardTooltipText = getAddCardTooltipText();

    const renderAddCardButton = () => {
        return (
            <Button
                id="demo-customized-button"
                aria-haspopup="true"
                variant="contained"
                disableElevation
                onClick={() => handleAddNewCard()}
                className={styles.whatsappTemplateFormButtons__addButton}
                disabled={isAddCardButtonDisabled}
                style={{ opacity: isAddCardButtonDisabled ? 0.5 : 1 }}
                startIcon={<IconsColor iconName="plus" width="10px" height="10px" fillColor={primaryColor} />}
            >
                Add Card
            </Button>
        )
    }

    return (
        <Accordion defaultExpanded={true} className={`${styles.accordion}`}>
            
            <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" className={styles.accordion__summary}>
                <Grid container justifyContent={"space-between"} alignItems={"center"}>
                    <span className={styles.accordion__summary__text}>
                       Cards <Required />
                    </span>

                    <span className={styles.accordion__summary__value}>
                        {`${getCarouselCards(createTemplatePayload)?.length}/${MAX_CAROUSEL_CARDS}`}
                    </span>
                </Grid>
            </AccordionSummary>

            <Divider sx={{ width: "100%", opacity: "1" }} />

            <AccordionDetails className={styles.accordion__details}>

                {shouldShowAddCardButton && (
                    <Grid item xs={12}>
                        {addCardTooltipText ? (
                            <TouchTooltip title={addCardTooltipText}>
                                <span className={globalStyles.clickable}>
                                    {renderAddCardButton()}
                                </span>
                            </TouchTooltip>
                        ) : (
                            renderAddCardButton()
                        )}
                    </Grid>
                )}

                {/* Accordian for Card */}

                <Grid item xs={12} className={shouldShowAddCardButton ? globalStyles.marginTop10px : ''}>
                    {getCarouselCards(createTemplatePayload)?.map((cardData: whatsappCarouselCardData, cardIndex: number) => (

                        <Accordion key={cardIndex} defaultExpanded={false} className={`${styles.accordion}`}>
                    
                            <AccordionSummary 
                                expandIcon={<GridExpandMoreIcon />} 
                                aria-controls="panel1a-content" 
                                id="panel1a-header" 
                                className={`${styles.accordion__summary}`}
                            >
                                <Grid container justifyContent={"space-between"} alignItems={"center"} flexWrap={"nowrap"}>
                                    <span className={styles.accordion__summary__subText}>
                                        {`Card: ${cardIndex + 1}`}
                                    </span>

                                    <Grid item display={"flex"} alignItems={"center"} gap={1} flexWrap={"nowrap"} sx={{ flexShrink: 0 }}>
                                        {canDeleteCard(createTemplatePayload) && (
                                            <DeleteIcon
                                                className={`${globalStyles.displayFlex} ${styles.deleteCardButton}`}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (canDeleteCard(createTemplatePayload)) {
                                                        handleDeleteCard(cardIndex);
                                                    }
                                                }}
                                            />
                                        )}
                                    </Grid>
                                </Grid>
                            </AccordionSummary>

                            <Divider sx={{ width: "100%", opacity: "1" }} />

                            <AccordionDetails className={styles.accordion__details}>

                                <Grid container xs={12} className={styles.whatsappTemplateFormButtons__callToActionGrid}>

                                    {/* Header */}
                                    <CarouselFormCardHeader 
                                        cardData={cardData} 
                                        cardIndex={cardIndex}
                                        carouselFiles={carouselFiles}
                                        uploadFileHandlerCarousel={uploadFileHandlerCarousel} 
                                        removeFileHandlerCarousel={removeFileHandlerCarousel} 
                                        isFileUploaded={isFileUploaded} 
                                    />

                                    {/* Body */}
                                    <CarouselFormCardBody
                                        cardData={cardData}
                                        cardIndex={cardIndex}
                                        handleChangeText={handleChangeText}
                                    />

                                    {/* Footer */}
                                    <CarouselFormCardFooter
                                        cardData={cardData}
                                        cardIndex={cardIndex}
                                        handleChangeText={handleChangeText}
                                    />

                                    {/* Buttons */}
                                    <CarouselFormCardButtons
                                        cardData={cardData}
                                        cardIndex={cardIndex}
                                        getInput={getInput}
                                        flagShowVariableTooltipForVisitWebsite={flagShowVariableTooltipForVisitWebsite}
                                        checkForAddDynamicVar={checkForAddDynamicVar}
                                        carouselInvalidId={carouselInvalidId}
                                        handleSampleTextChangeCarousel={handleSampleTextChangeCarousel}
                                        getWebsiteUrlValue={getWebsiteUrlValue}
                                    />

                                    {/* Body Description */}
                                    {/* <CarouselFormCardBodyDescription
                                        cardData={cardData}
                                        cardIndex={cardIndex}
                                    /> */}
                                
                                </Grid>

                            </AccordionDetails>
                        
                        </Accordion>
                    ))}
                </Grid>

            </AccordionDetails>
        </Accordion>
    )

}

export default CarouselFormCard;